<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="
                $l('form_label_function_operator_log_search') ||
                  '功能编码/操作人员/日志类型搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="medium" label-position="top">
        <el-row>
          <el-form-item :label="$l('form_label_operator') || '操作人员'">
            <dict-select
              clearable
              v-model="form.userCodeList"
              :body="{}"
              url="/sys/common/dict/userDict"
              :placeholder="$l('from_label_please_operator') || 请选择操作人员"
              filterable
              multiple
            ></dict-select>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('form_label_function_code') || '功能编码'">
              <el-input
                v-model.trim="form.funcID"
                :placeholder="
                  $l('form_label_pleaseEnter_function_code') || '请输入功能编码'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('form_label_log_type') || '日志类型'">
              <el-input
                v-model.trim="form.logType"
                :placeholder="
                  $l('form_label_pleaseEnter_log_type') || '请输入日志类型'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('form_label_ip') || 'ip'">
              <el-input
                v-model.trim="form.ip"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-row>
              <el-form-item :label="$l('form_label_log_date') || '日志时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.logBeginTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$l('form_label_option_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.logEndTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$l('form_label_option_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  searchKey: '',
  logBeginTime: null,
  logEndTime: null,
  userCodeList: [],
}
import dayjs from '@/libs/util.date'
export default {
  data() {
    const validateDate = (rule, value, callback) => {
      if (!this.form.logBeginTime || !this.form.logEndTime) {
        callback()
        return
      }

      const validDays = dayjs(this.form.logEndTime).diff(
        this.form.logBeginTime,
        'day'
      )
      if (validDays < 0) {
        callback(new Error('结束日期不能小于开始日期'))
      } else {
        callback()
      }
    }
    return {
      advqueryDialogVisible: false,
      form: { ...initForm, validDays: null },
      defaultBegin: Date,
      pickerOptionsBegin: {
        disabledDate: (time) => {
          let curDate = new Date().getTime()
          let day = 30 * 24 * 3600 * 1000
          let dateRegion = curDate - day
          return (
            time.getTime() > Date.now() - 8.6e7 || time.getTime() < dateRegion
          )
        },
      },
      rules: {
        logBeginTime: [
          {
            required: true,
            message: '请选择开始时间',
            trigger: 'change',
          },
          {
            message: '开始时间不能大于结束时间',
            trigger: 'change',
            validator: validateDate,
          },
        ],
        logEndTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' },
          {
            message: '结束时间不能小于开始时间',
            trigger: 'change',
            validator: validateDate,
          },
        ],
      },
    }
  },
  created() {
    this.defaultTime()
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.searchKey = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
      this.defaultTime()
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    defaultTime() {
      // 当天时间
      let data = new Date()
      let year, month, day
      ;[year, month, day] = [
        data.getFullYear(),
        data.getMonth(),
        data.getDate(),
      ]
      let data1 = new Date(year, month, day, 0)

      this.form.logBeginTime = data1

      //前一天时间
      let year2, month2, day2
      data.setTime(data.getTime() - 24 * 60 * 1000)
      ;[year2, month2, day2] = [
        data.getFullYear(),
        data.getMonth(),
        data.getDate(),
      ]
      let data2 = new Date(year2, month2, day2, 24)
      this.form.logEndTime = data2
    },
    cacalDays() {
      if (this.form.logBeginTime && this.form.logEndTime) {
        let data = new Date(this.form.logEndTime)
        const validDays = dayjs(data).diff(this.form.logBeginTime, 'day')
        this.form.validDays = validDays < 0 ? 0 : validDays
      }
    },
    // cacalDate() {
    //   if (!this.form.logBeginTime) return
    //   let data = new Date(this.form.logBeginTime)
    //   this.form.logEndTime = dayjs(data.toLocaleDateString())
    //     .add(this.form.validDays, 'day')
    //     .format('YYYY-MM-DD')
    //     alert(this.form.logEndTime)
    // },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
